import React from 'react';

export default function UvildigraadFrontPage() {
    return <img style={{ marginLeft: 'auto', marginRight: 'auto', width: '450px', height: 'auto' }} src="/assets/img/uvildigraad/logo.png" />;
}
